export default class NotificationInboxEmpty {
  view(vnode) {
    const mode = vnode.attrs.mode;
    if (mode === 'loading') {
      return m("p", {
        className: "NotificationInboxEmpty"
      }, "Loading notifications.");
    }
    if (mode === 'unavailable' || mode === 'partial') {
      return m("p", {
        className: "NotificationInboxEmpty"
      }, "Some notifications could not be loaded.");
    }
    if (mode === 'caught-up') {
      return m("p", {
        className: "NotificationInboxEmpty"
      }, "You're all caught up.");
    }
    if (mode === 'signed-out') {
      return m("p", {
        className: "NotificationInboxEmpty"
      }, "Sign in to view notifications.");
    }
    return null;
  }
}
flarum.reg.add('flatrate-messaging-ui', 'forum/components/NotificationInboxEmpty', NotificationInboxEmpty);